import http from '@/utils/http'

export function getAssessments(params){
    return http.get('/assessments',{params})
}
export function addAssessment(data){
    return http.post('/assessments',data)
}
export function getAssessmentDetail(id){
    return http.get(`/assessments/${id}`)
}
export function putAssessment(id,data){
    return http.put(`/assessments/${id}`,data)
}
export function deleteAssessment(id){
    return http.delete(`/assessments/${id}`)
}

